import { defineMessages } from 'react-intl';

export const scope = 'app.components.ParentAddContact';

// Copy for the parent-facing "add a co-contact to one of my players" dialog.
export const messages = defineMessages({
  cancel: { id: `${scope}.cancel`, defaultMessage: 'Cancel' },

  addContactAction: { id: `${scope}.addContactAction`, defaultMessage: 'Add additional contact to a player' },
  addContactTitle: { id: `${scope}.addContactTitle`, defaultMessage: 'Add additional contact to a player' },
  addContactIntro: {
    id: `${scope}.addContactIntro`,
    defaultMessage: 'Add a second parent or guardian so they get their own notifications. They\'ll see this player once they sign in with the email or phone you enter.',
  },
  lblPlayer: { id: `${scope}.lblPlayer`, defaultMessage: 'Player' },

  addContactSubmit: { id: `${scope}.addContactSubmit`, defaultMessage: 'Add contact' },
  addContactSubmitting: { id: `${scope}.addContactSubmitting`, defaultMessage: 'Adding…' },
  addContactSuccess: {
    id: `${scope}.addContactSuccess`,
    defaultMessage: 'Added {name} as a contact for {playerName}.',
  },
  addContactError: {
    id: `${scope}.addContactError`,
    defaultMessage: 'Couldn\'t add that contact. Please try again.',
  },

  errPlayerRequired: { id: `${scope}.errPlayerRequired`, defaultMessage: 'Choose a player' },
  errNameRequired: { id: `${scope}.errNameRequired`, defaultMessage: 'Enter a name' },
  errEmailInvalid: { id: `${scope}.errEmailInvalid`, defaultMessage: 'Email is invalid' },
  errPhoneInvalid: { id: `${scope}.errPhoneInvalid`, defaultMessage: 'Phone is invalid' },
  errCredentialRequired: {
    id: `${scope}.errCredentialRequired`,
    defaultMessage: 'Enter an email or a phone number',
  },
  errEmailDuplicate: {
    id: `${scope}.errEmailDuplicate`,
    defaultMessage: 'That email is already a contact for this player',
  },
  errPhoneDuplicate: {
    id: `${scope}.errPhoneDuplicate`,
    defaultMessage: 'That phone number is already a contact for this player',
  },
});
